import {
  ADMIN_BILLING_GET,
  ADMIN_BILLING_GET_SUCCESS,
  ADMIN_BILLING_GET_FAIL,
  ADMIN_BILLING_CLEAR,
} from './types';

export const initialState = {
  loading: false,
  data: {},
};

const reducer = (state = initialState, action) => {
  const { type } = action;
  switch (type) {
    case ADMIN_BILLING_GET: {
      return { ...state, loading: true, data: {} };
    }
    case ADMIN_BILLING_GET_SUCCESS: {
      const { data } = action.payload;
      return { ...state, loading: false, data };
    }
    case ADMIN_BILLING_GET_FAIL: {
      return { ...state, loading: false, data: {} };
    }
    case ADMIN_BILLING_CLEAR: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
